import React from "react";
import { useTranslation } from "react-i18next";

export default function MeasurementCard({ title, data, type, unit }) {
  const { t } = useTranslation();
  let items = [];
  if (type === "voltage-phase") {
    items = [
      { key: "VL1", label: t("chartLabels.L1N") },
      { key: "VL2", label: t("chartLabels.L2N") },
      { key: "VL3", label: t("chartLabels.L3N") },
    ];
  } else if (type === "voltage-line") {
    items = [
      { key: "VL12", label: t("chartLabels.L12") },
      { key: "VL23", label: t("chartLabels.L23") },
      { key: "VL31", label: t("chartLabels.L31") },
    ];
  } else if (type === "current") {
    items = [
      { key: "I1", label: t("chartLabels.I1") },
      { key: "I2", label: t("chartLabels.I2") },
      { key: "I3", label: t("chartLabels.I3") },
      { key: "IN", label: t("chartLabels.neutral") },
    ];
  }

  const formatValue = (val) => {
    if (val === null || val === undefined) return "-";
    if (isNaN(val)) return val;
    return Number(val).toFixed(2);
  };

  return (
    <div className="bg-white rounded-2xl shadow-md p-6 flex flex-col">
      <h2 className="text-lg font-semibold text-gray-800 mb-4">{title}</h2>
      <div className={`grid grid-cols-2 ${type === "current" ? "md:grid-cols-4" : "md:grid-cols-3"} gap-4 text-center`}>
        {items.map((item) => (
          <div
            key={item.key}
            className="border rounded-lg p-3 bg-gray-50 shadow-sm"
          >
            <p className="text-sm font-medium text-gray-700">{item.label}</p>
            <p className="text-xs text-green-700">
              {t("common.max")}: {formatValue(data?.[`${item.key}_MAX`])} {unit}
            </p>
            <p className="text-xs text-red-700">
              {t("common.min")}: {formatValue(data?.[`${item.key}_MIN`])} {unit}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
